module.exports = __webpack_public_path__ + "img/sa7.3029b802.png";